import { getYouSayIDDetails } from '../../Graphql/queries'
import AppSyncClient from '../../Utils/AppSyncClient'

const GetYouSayIdDetails = async (input) => {
	try {
		const { data } = await AppSyncClient.query({
			query: getYouSayIDDetails,
			variables: input,
			fetchPolicy: 'no-cache',
		})
		return data.getYouSayIDDetails
	} catch (error) {
		return false
	}
}

export default GetYouSayIdDetails
